import * as Sentry from '@sentry/react'
import { API_BASE_URL, X_API_KEY } from './api'

export const viewAnnounce = async (announceId: number) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/announce/${announceId}/view`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': X_API_KEY,
        },
      },
    )
    if (!response.ok) {
      throw new Error('Network response was not ok')
    }
    return response.json()
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        action: 'viewAnnounce',
        announceId,
        timestamp: new Date().toISOString(),
      },
      tags: {
        type: 'api_error',
        method: 'viewAnnounce',
      },
    })
    throw error
  }
}
